module.exports = __webpack_public_path__ + "static/img/design2.81f32b0c.png";